import { useMutation } from '@tanstack/react-query';
import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationActiveCell({ rowData, onChange }: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const { showToast } = useNotificationContext();
    const { mutate: setLocationActive, isPending } = useMutation({
        meta: { name: 'update-location' },
        mutationFn: (isActive: boolean) =>
            updateLocation(rowData, { IsActive: isActive }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location active status',
            }),
    });

    return (
        <SwitchInlineEditor
            value={rowData.Active}
            onConfirm={(val) => setLocationActive(val ?? false)}
            isDisabled={isPending || !canEditLocationDetails}
            renderValue={(val) => (val ? 'Yes' : 'No')}
        />
    );
}
